import React from 'react';
import { getDate } from 'globals/utils';
import FsBody from 'ui-elements/typography/FsBody';

interface FsCurrencyProps {
  format?: string;
}

const FsStandardizedDate: React.FC<FsCurrencyProps> = ({
  format,
  children,
}) => {
  return (
    <FsBody>
      {getDate({
        format,
        value: typeof children === 'number' ? children : new Date().getTime(),
      })}
    </FsBody>
  );
};

export default FsStandardizedDate;
